<template>
	<div class="group">
		<sort 
			:class="sortClass" 
			v-for="item in sorts" 
			:key="item.name" 
			:label="item.label" 
			@onChange="sortChange" 
			:name="item.name" 
			:ref="item.name"
			:initStatus="item.initStatus"
		></sort>
	</div>
</template>
<script>
import sort from './index'
export default {
	name: "sort-group",
	components:{
		sort,
	},
	props:{
		sorts:{
			validator(value){
				return Array.isArray(value) && value.every(item=>item.label && item.name)
			}
		},
		sortClass:{
			type:String
		},
		type:{
			type:String,
			default:'multiple'
		}
	},
	emits: ['on-change'],
	data() {
		return {
			status: null,
		};
	},
	methods: {
		sortChange(status,name){
			this.$emit('onChange',status,name)
			if(this.type == 'single'){
				for(let i=0;i<this.sorts.length;i++){
					let sname = this.sorts[i].name
					if(sname != name){
						this.$refs[sname][0].status = null
					}
				}
			}
		}
	},
};
</script>
<style lang="scss" scoped>

	.group{
		display: flex;
	}

</style>
      